// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import { getCurrentEditingUser } from "@insite/client-framework/Store/Pages/UserSetup/UserSetupSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import HistoryContext from "@insite/mobius/utilities/HistoryContext";
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import useIsApprovalRequired from "@store/Framework/Store/Data/Accounts/Hooks/useIsApprovalRequired";
import { hasChanges } from "@store/Framework/Store/Pages/UserSetup/UserSetupSelectors";
import React, { useContext } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    editingUser: getCurrentEditingUser(state),
    disableSaveButton:
        !hasChanges(state) ||
        !!state.pages.userSetup.emailErrorMessage ||
        !!state.pages.userSetup.firstNameErrorMessage ||
        !!state.pages.userSetup.lastNameErrorMessage,
    cancelPageLink: getPageLinkByPageType(state, "UserListPage"),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface UserSetupSubmitStyles {
    saveButton?: ButtonPresentationProps;
    cancelButton?: ButtonPresentationProps;
}

export const userSetupSubmitStyles: UserSetupSubmitStyles = {
    saveButton: { variant: "primary" },
    cancelButton: { variant: "secondary" },
};

const styles = userSetupSubmitStyles;

const UserSetupSubmit = ({ editingUser, disableSaveButton, cancelPageLink }: Props) => {
    const { history } = useContext(HistoryContext);
    // Store Custom Code - >
    const approverNeedsAproval = useIsApprovalRequired();
    // <-- Bunzl Custom Code
    if (!editingUser) {
        return null;
    }

    const approverIsValid = (role: string) => {
        if (!approverNeedsAproval(role)) {
            return true;
        }
        if (editingUser.approver) {
            return true;
        }

        return false;
    };

    const onCancelClick = () => {
        if (cancelPageLink) {
            history.push(cancelPageLink.url);
        }
    };

    return (
        <FormActions>
            <Button
                {...styles.saveButton}
                type="submit"
                disabled={disableSaveButton || !approverIsValid(editingUser.role)}
            >
                {translate("Save")}
            </Button>
            {cancelPageLink?.url ? (
                <Button
                    {...styles.cancelButton}
                    type="button"
                    onClick={onCancelClick}
                    data-test-selector="userSetupHeader_cancelButton"
                >
                    {translate("Cancel")}
                </Button>
            ) : null}
        </FormActions>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(UserSetupSubmit),
    definition: {
        group: "User Setup",
        displayName: "Submit Buttons",
        allowedContexts: ["UserSetupPage"],
    },
};

export default widgetModule;
